module.exports = __webpack_public_path__ + "static/detail.febe4331.jpg";